import { createContext } from 'react';

export const SubscriptionContext = createContext({
  activeSubscription: null,
  benefits: [],
  updateSubscription: () => {},
  updateBenefits: () => {},
  clearSubscription: () => {},
});
